import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
const FLYER_IMAGE = 'https://cdn.magicpatterns.com/uploads/2dNSBTn6iSNX6Dy9DTiCmz/1.png';
export function Tour() {
  // Load the Laylo SDK once on mount so the embed renders
  useEffect(() => {
    const SRC = 'https://embed.laylo.com/laylo-sdk.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-289">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-290">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-291">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-292">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-293">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-294">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-295">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-296">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-297">
          contact
        </a>
      </header>

      {/* Tour content */}
      <section className="mt-16 flex w-full flex-col items-center text-sm md:mt-24" data-id="element-298">
        {/* Flyer */}
        <img src={FLYER_IMAGE} alt="The first, last and only Florida tour flyer" className="h-auto w-full max-w-md" style={{
        mixBlendMode: 'multiply'
      }} draggable={false} data-id="element-299" />

        {/* Ticket / RSVP message */}
        <p className="mt-12 text-center lowercase" data-id="element-300">
          tickets will be available for purchase soon. rsvp for updates
        </p>

        {/* Smaller Laylo embed */}
        <div className="mt-6 w-full max-w-xs pb-24" data-id="element-301">
          <iframe id="laylo-drop-4ekga-tour" frameBorder="0" scrolling="no" allow="web-share" allowTransparency title="RSVP for updates" style={{
          width: '1px',
          minWidth: '100%',
          maxWidth: '1000px'
        }} src="https://embed.laylo.com?dropId=4ekga&color=000000&minimal=true&theme=light&background=transparent&customTitle=rsvp" data-id="element-302" />
        </div>
      </section>
    </main>;
}